import { useState } from 'react';
import TopNav from "../../home/components/TopNav";
export default function EmbeddedContentPage() {
  const [iframeUrl] = useState<string>('https://www.daditu.com.cn/zxzt/mapping.html');

  return (
    <div className="w-screen h-screen overflow-hidden">
      <TopNav />

      {/* iframe 从顶部导航下方开始 */}
      <iframe
        src={iframeUrl}
        className="w-full h-full border-0"
      />
    </div>
  );
}